import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from './app/providers.js';
import { createQueryClient } from './app/query-client.js';
import { createAppRouter } from './app/router.js';
import { applyDocumentLanguage, createI18n } from './i18n/index.js';
import './styles.css';

const queryClient = createQueryClient();
const i18n = createI18n();
const router = createAppRouter(queryClient);

// `<html lang>` follows the chosen language from the first paint and on every change.
applyDocumentLanguage(i18n.resolvedLanguage ?? 'en');
i18n.on('languageChanged', applyDocumentLanguage);

const container = document.querySelector('#root');
if (container === null) {
  throw new Error('index.html has no #root element');
}

createRoot(container).render(
  <StrictMode>
    <Providers queryClient={queryClient} i18n={i18n}>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
